import { useNuxtApp, ref, useState } from "#imports";
export function useChat() {
  const { $chat } = useNuxtApp();
  const isSending = ref(false);
  const isConnected = useState("isConnected", () => false);
  const messages = useState("messages", () => []);
  const connectWithProvider = async (tokenProvider) => {
    try {
      const { user, token, name, channelType, channelId } = await tokenProvider();
      await $chat.connect(user, token, name);
      await $chat.setConversation(channelType, channelId);
      messages.value = $chat.getMessages();
      $chat.onMessageReceived((streamMessage) => {
        messages.value.push(streamMessage);
      });
      isConnected.value = true;
    } catch (error) {
      console.error("Chat connection failed:", error);
      isConnected.value = false;
      throw error;
    }
  };
  async function sendMessage(text) {
    if (!text.trim()) {
      throw new Error("Message cannot be empty");
    }
    if (!isConnected.value) {
      throw new Error("Chat is not connected, sendMessage failed");
    }
    isSending.value = true;
    try {
      await $chat.sendMessage(text);
    } finally {
      isSending.value = false;
    }
  }
  return {
    messages,
    isConnected,
    isSending,
    connectWithProvider,
    sendMessage
  };
}
